module.exports = __webpack_public_path__ + "static/img/pic_ship_big@2x.d5fd7cc4.png";